import { configureStore } from '@reduxjs/toolkit';
import appSlice from '../features/app/slice';
import { gladosApi } from '../api/glados';
import { tradeInApi } from '../api/tradeIn';
import { listener } from './listener';
import { validationApi } from '@vfde-sails/validation';
import {
    overlayApi,
    overlaySlice,
} from '@vfde-sails/overlay';
import tradeInSlice from '../features/tradeIn/slice';

export const store = configureStore({
    reducer: {
        [appSlice.reducerPath]: appSlice.reducer,
        [tradeInSlice.reducerPath]: tradeInSlice.reducer,
        [gladosApi.reducerPath]: gladosApi.reducer,
        [tradeInApi.reducerPath]: tradeInApi.reducer,
        [overlaySlice.reducerPath]: overlaySlice.reducer,
        [overlayApi.reducerPath]: overlayApi.reducer,
        [validationApi.reducerPath]: validationApi.reducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware()
            .prepend(listener.middleware) // listener goes first because of special actions in it
            .concat(
                gladosApi.middleware,
                tradeInApi.middleware,
                overlayApi.middleware,
                validationApi.middleware,
            ),
});

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 */
export type RootState = ReturnType<typeof store.getState>;

/**
 * Infer AppDispatch
 */
export type AppDispatch = typeof store.dispatch;

/**
 * Hook-like function to dispatch actions
 */
export const useAppDispatch = () => store.dispatch;
